
<template>
  <div>
    <div :class="hidedata?'l-d l-d-l':'l-d'">
      <div>
        <i @click="hideLeft" v-if="!hidedata" class="el-icon-d-arrow-left rg"></i>
        <i @click="hideLeft" v-else class="el-icon-d-arrow-right rg"></i>
        <div class="l-t">
          <template v-if="isHotCity">{{hotZoneAreas[0].cityName}}道路排行 TOP30</template>
          <template v-else>途径{{hotZoneAreas[0].cityName}}道路排行</template>
          <div v-if="!isHotCity">
            <img width="16" src="../../../assets/images/year.png" />年运营
            <img class="img" width="16" src="../../../assets/images/day.png" />日运营
          </div>
        </div>
        <div class="l-btn" v-if="!isHotCity">
          <el-button
            v-for="(i,k) in btnData"
            :key="k"
            :class="btnIndex==i.name?'a-btn':''"
            @click="getData(k,i.name)"
            size="small"
          >{{i.name}}</el-button>
        </div>
        <div class="l-cont l-contnew">
          <ul class="animate">
            <div
              v-for="(i,k) in listData"
              :key="k"
              :class="i.isShow?'a':k==activeIndex?'aClick':''"
              @mouseover="overFun(k)"
              @click="clickFun(i.id)"
              @mouseout="outFun"
            >
              <h5 v-html="i.highSpeedName"></h5>
              <div class="lb">
                <div :style="{width: i.percentage+'%',background:i.color}" class="gr"></div>
              </div>
              <div class="l-bot" v-if="isHotCity">
                日均运营车次
                <span>{{i.dayOperate}}</span>
              </div>
              <div class="l-bot" v-else>
                <img width="16" src="../../../assets/images/year.png" />
                <span>{{i.yearOperate}}</span>
                <div>
                  <img width="16" src="../../../assets/images/day.png" />
                  <span>{{i.dayOperate}}</span>
                </div>
              </div>
            </div>
          </ul>
        </div>
      </div>
    </div>
    <!-- 颜色 -->
    <colorSign :hidedata="hidedata" />
  </div>
</template>
 
<script>
import colorSign from '../mapComponents/colorSign.vue'
export default {
  components: {
    colorSign
  },
  data() {
    return {
      animate: false,
      hidedata: false,
      btnData: [
        { name: '全部' },
        { name: '高速' },
        { name: '国道' },
        { name: '省道' }
      ],
      activeIndex: '-1',
      listData: []
    }
  },
  props: {
    hotZoneAreas: {
      type: Array,
      default: () => {
        return []
      }
    },
    leftData: {
      type: Array,
      default: () => {
        return []
      }
    },
    leftIndex: Number,
    btnIndex: String,
    isHotCity: Boolean
  },

  watch: {
    leftIndex(val, oldVal) {
      if (val !== null) {
        this.clickFun(val)
      }
    },
    leftData(val, oldVal) {
      if (val !== null) {
        this.listData = this.leftData
      }
    }
  },
  computed: {},
  created() {
    this.listData = this.leftData
  },
  methods: {
    // 根据点击定位左侧
    changeTop(k) {
      document.querySelector('.l-contnew').scrollTop = 110 * k
    },
    getData(k, name) {
      this.$emit('initData', name, true)
    },
    hideLeft() {
      this.hidedata = !this.hidedata
      this.$emit('isShowList', this.hidedata)
    },
    // 鼠标放上去事件
    overFun(i) {
      this.activeIndex = i
    },
    clickFun(id) {
      var listData = this.listData
      this.activeIndex = '-1'
      this.$emit('changeLeftIndex', id)
    },
    outFun() {
      this.activeIndex = -1
    }
  }
}
</script>
